// eslint-disable-next-line no-restricted-imports
import { SvgIcon, SvgIconProps } from '@mui/material';
import Svg from '@rhg/../public/_n/images/icons/flag-kids.svg';

export const FlagKids = (props: SvgIconProps) => (
    <SvgIcon component={Svg} inheritViewBox {...props} />
);
